// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"408a0595","453":"6fb7522b","455":"b277b46d","977":"b79338d2"}[chunkId] + ".chunk.js";
};